import React, { use, useEffect, useState } from "react";

import AdminAssessmentTable from "../../SVTAssessment/AdminAssessmentTable";
import AssessmentView from "./AssessmentView";
import { getAllSlots } from "../../../../services/svt/svt-admin/slot-management.service";
import { getAllLevels } from "../../../../services/svt/svt-admin/level-management.service";
import Loader from "../../../common/Loader/Loader";
import i18n from "i18next";
const t = i18n.t.bind(i18n);

const AssessmentManagement = () => {
    const [activeTab, setActiveTab] = useState("Tab1");
    const [assessmentdetails, setAssessmentDetails] = useState([]);
    const [modalMode, setModalMode] = useState("");
    const [slotData, setSlotData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [isAddQueModalOpen, setIsAddQueModalOpen] = useState(false);
    const [assessmentPayload, setAssessmentPayload] = useState('');
    const [levelsList, setLevelsList] = useState([]);
    const [tableRowData, setTableRowData] = useState([]);

    useEffect(() => {
        fetchSlotData();
        fetchLevels();

    }, []);

    const fetchLevels = async () => {
        try {
            setLoading(true);
            const levelsResult = await getAllLevels();
            const updatedData = levelsResult.data.map((item) => ({
                ...item,
                label: t(item.name.toLowerCase()),
                value: item.id
            }));
            setLevelsList(updatedData);
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setLoading(false);
        }
    };

    const fetchSlotData = async () => {
        try {
            setLoading(true);
            const slotsResult = await getAllSlots();
            setSlotData(slotsResult.data);
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setLoading(false);
        }
    };

    const renderContent = () => {
        switch (activeTab) {
            case "Tab1":
                return (
                    <AdminAssessmentTable
                        setActiveTab={setActiveTab}
                        setAssessmentDetails={setAssessmentDetails}
                        modalMode={modalMode}
                        setModalMode={setModalMode}
                        setIsAddQueModalOpen={setIsAddQueModalOpen}
                        setAssessmentPayload={setAssessmentPayload}
                        setTableRowData={setTableRowData}
                    />
                );
            case "Tab2":
                return (
                    <AssessmentView
                        setActiveTab={setActiveTab}
                        assessmentdetails={assessmentdetails}
                        setAssessmentDetails={setAssessmentDetails}
                        modalMode={modalMode}
                        setModalMode={setModalMode}
                        slotData={slotData}
                        isAddQueModalOpen={isAddQueModalOpen}
                        setIsAddQueModalOpen={setIsAddQueModalOpen}
                        levelsList={levelsList}
                        activeTab={activeTab}
                        assessmentPayload={assessmentPayload}
                        tableRowData={tableRowData}
                    />
                );
            default:
                return null;
        }
    };
    return <>{loading ? <Loader /> : renderContent()}</>;
};

export default AssessmentManagement;
